// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import {
	AcademicYear,
	Student,
	StudentEnrollmentIntent,
	StudentEnrollmentIntentDeclineReason,
} from "../../../Utilities";

export type Base = {
	isEnrolling: StudentEnrollmentIntent["isEnrolling"];
	isInterestedInMealPlan: StudentEnrollmentIntent["isInterestedInMealPlan"];
	declineReason: StudentEnrollmentIntent["declineReason"] | null;
	declineReasonDescription: StudentEnrollmentIntent["declineReasonDescription"];
	academicYearID: AcademicYear["id"] | null;
	studentID: Student["id"] | null;
};

export type Create = Base;

export type CreateRequiredKey = Extract<keyof Create, "academicYearID" | "studentID">;

export type CreateSubset<K extends keyof Create = keyof Create> = Pick<Create, CreateRequiredKey | K>;

export const initialCreate: Create = {
	isEnrolling: false,
	isInterestedInMealPlan: false,
	declineReason: null,
	declineReasonDescription: "",
	academicYearID: null,
	studentID: null,
};

export type Detail = Base & {
	createdAt: StudentEnrollmentIntent["createdAt"] | null;
};

export type DetailSubset<K extends keyof Detail = keyof Detail> = Pick<Detail, K>;

export const declineReasonOptions = [
	{ value: StudentEnrollmentIntentDeclineReason.Academic },
	{ value: StudentEnrollmentIntentDeclineReason.Administrative },
	{ value: StudentEnrollmentIntentDeclineReason.Financial },
	{ value: StudentEnrollmentIntentDeclineReason.Graduating },
	{ value: StudentEnrollmentIntentDeclineReason.Health },
	{ value: StudentEnrollmentIntentDeclineReason.Other },
	{ value: StudentEnrollmentIntentDeclineReason.Relocation },
	{ value: StudentEnrollmentIntentDeclineReason.Social },
];
